import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-fluid formgrid grid" }
const _hoisted_2 = { class: "field col-12 lg:col-7" }
const _hoisted_3 = { class: "field col-12 lg:col-3" }
const _hoisted_4 = { class: "field col-12 lg:col-2 text-right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { style: {"display":"block"} }, " ", -1)
const _hoisted_6 = {
  key: 0,
  class: "col-12"
}
const _hoisted_7 = {
  key: 1,
  class: "field col-12 text-right"
}
const _hoisted_8 = {
  key: 2,
  class: "col-12"
}
const _hoisted_9 = {
  key: 0,
  class: "badge status-red"
}
const _hoisted_10 = {
  key: 1,
  class: "badge status-orange"
}
const _hoisted_11 = {
  key: 2,
  class: "badge status-green"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 4,
  class: "badge status-purple"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.handleSubmit()), ["prevent"])),
    onKeydown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleKeydown($event)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("statItemCode.company")), 1),
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.companyId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyId) = $event)),
          options: _ctx.companies,
          onChange: _ctx.dataChanged,
          optionLabel: "name",
          optionValue: "id",
          placeholder: "-"
        }, null, 8, ["modelValue", "options", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("statItemCode.itemCode")), 1),
        _createVNode(_component_InputText, {
          modelValue: _ctx.itemCode,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.itemCode) = $event)),
          type: "text",
          onChange: _ctx.dataChanged
        }, null, 8, ["modelValue", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_Button, {
          label: _ctx.t('buttons.search'),
          icon: "pi pi-search",
          type: "submit",
          class: "p-button-primary p-uppercase"
        }, null, 8, ["label"])
      ]),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_Divider)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults && _ctx.results.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_Button, {
              label: _ctx.t('buttons.print'),
              icon: "pi pi-print",
              class: "p-button-primary p-uppercase",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printReport()))
            }, null, 8, ["label"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_DataTable, {
              dataKey: "id",
              responsiveLayout: "scroll",
              showGridlines: "",
              sortField: _ctx.sortField,
              sortOrder: _ctx.sortOrder,
              stripedRows: "",
              value: _ctx.results,
              "onUpdate:sortField": _ctx.onSortFieldUpdate,
              "onUpdate:sortOrder": _ctx.onSortOrderUpdate
            }, {
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.noData")), 1)
              ]),
              loading: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.loading")), 1)
              ]),
              footer: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.t("statItemCode.itemCodeCount")) + ": " + _toDisplayString(_ctx.n(_ctx.itemCodeCount, "number0")), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "code",
                  header: _ctx.t('statItemCode.code'),
                  sortable: "",
                  headerStyle: "width: 15%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createTextVNode(_toDisplayString(data[field] ? data[field] : "-"), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "inboundShipment",
                  sortField: "inboundShipment.date",
                  header: _ctx.t('statItemCode.inboundShipment'),
                  sortable: "",
                  headerStyle: "width: 30%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createTextVNode(_toDisplayString(data[field]
                  ? _ctx.t("statItemCode.shipmentDetail", {
                      code: data[field].code,
                      date: _ctx.d(data[field].date, "shortDate"),
                      companyName: data[field].company.name,
                    })
                  : "-"), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "items",
                  header: _ctx.t('statItemCode.items'),
                  headerStyle: "width: 20%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data[field], (parcelItem) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: parcelItem,
                        class: "badge status-green mr-4"
                      }, _toDisplayString(`${parcelItem.code}: ${_ctx.n(parcelItem.quantity, "number0")}`), 1))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "state",
                  header: _ctx.t('statItemCode.parcelState'),
                  bodyClass: "text-center",
                  headerStyle: "width: 20%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    (data[field] == 'deleted')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.t(`statItemCode.parcelStates.${data[field]}`)), 1))
                      : (data[field] == 'loosened')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.t(`statItemCode.parcelStates.${data[field]}`)), 1))
                        : (data[field] == 'sent' || data[field] == 'loaded')
                          ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_11, [
                              _createTextVNode(_toDisplayString(_ctx.t(`statItemCode.parcelStates.${data[field]}`)), 1)
                            ])), [
                              [
                                _directive_tooltip,
                                
                  `${_ctx.t('statItemCode.shipmentDetail', {
                    code: data.outboundShipment.code,
                    date: _ctx.d(data.outboundShipment.date, 'shortDate'),
                    companyName: data.outboundShipment.company.name,
                  })}`
                ,
                                void 0,
                                { top: true }
                              ]
                            ])
                          : (data[field] == 'stored')
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 3,
                                class: "badge status-blue",
                                style: {"cursor":"pointer"},
                                onClick: ($event: any) => (_ctx.showWarehouseLocationDetails(data.warehouseLocation))
                              }, _toDisplayString(_ctx.t(`statItemCode.parcelStates.${data[field]}`)), 9, _hoisted_12))
                            : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.t("statItemCode.parcelStates.unknown")), 1))
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "warehouseLocation",
                  sortField: "warehouseLocation.code",
                  header: _ctx.t('statItemCode.warehouseLocation'),
                  sortable: "",
                  bodyClass: "text-center",
                  headerStyle: "width: 15%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    (data[field])
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(data[field].code), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_15, "-"))
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }, 8, ["sortField", "sortOrder", "value", "onUpdate:sortField", "onUpdate:sortOrder"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 32))
}